import React from 'react'
import { Grid, GridItem } from '../../components/grid'
import Spacer from '../../components/spacer'
import ImageScale from '../../components/scale/image_scale'
import css from './style.css'

const ClaritySection = props => {
  /** -------------- */
  /** CLARITY SCALE  */
  /** -------------- */

  const flawless = require('./images/clarityScale/flawless@2x.png')
  const internallyFlawless = require('./images/clarityScale/internallyFlawless@2x.png')
  const VVS1 = require('./images/clarityScale/VVS1@2x.png')
  const VVS2 = require('./images/clarityScale/VVS2@2x.png')
  const VS1 = require('./images/clarityScale/VS1@2x.png')
  const VS2 = require('./images/clarityScale/VS2@2x.png')
  const SI1 = require('./images/clarityScale/SI1@2x.png')
  const SI2 = require('./images/clarityScale/SI2@2x.png')
  const I1 = require('./images/clarityScale/I1@2x.png')
  const I2 = require('./images/clarityScale/I2@2x.png')
  const I3 = require('./images/clarityScale/I3@2x.png')

  const clarityScale = [
    {
      elements: [
        { img: flawless, name: 'Flawless' },
        { img: internallyFlawless, name: 'Internally Flawless' }
      ],
      description: ''
    },
    {
      elements: [
        { img: VVS1, name: 'VVS1' },
        { img: VVS2, name: 'VVS2' }
      ],
      description: 'Very Very Slightly Included'
    },
    {
      elements: [
        { img: VS1, name: 'VS1' },
        { img: VS2, name: 'VS2' }
      ],
      description: 'Very Slightly Included'
    },
    {
      elements: [
        { img: SI1, name: 'SI1' },
        { img: SI2, name: 'SI2' }
      ],
      description: 'Slightly Included'
    },
    {
      elements: [
        { img: I1, name: 'I1' },
        { img: I2, name: 'I2' },
        { img: I3, name: 'I3' }
      ],
      description: 'Included'
    }
  ]
  return (
    <div>
      <Grid>
        <div className={css.pinkBg2} />
        <GridItem col='3/5' customStyle={css.gridItem}>
          <img className={css.image}
            src={require('./images/clarity_diamond_ring.png')}
            srcSet={[
              require('./images/clarity_diamond_ring.png') + ' 1x',
              require('./images/clarity_diamond_ring@2x.png') + ' 2x'
            ].join(', ')}
          />
        </GridItem>
        <GridItem col='1/10' customStyle={css.gridItem} />
        <GridItem col='3/10' customStyle={css.gridItem}>
          <div className={css.title}>
            Clarity
          </div>
          <p className={css.text}>
            As diamonds are created naturally, no two diamonds are alike. During the growth of the stone, impurities and blemishes naturally develop. These inclusions appear in different sizes, colours and shapes and in different locations of the diamond. All of these criteria contribute to the clarity grade of a diamond. We carefully select only the nicest and brightest diamonds of each clarity grade. No visible black spots or hazy material. We also make sure that all our diamonds are 100% clean of inclusions to the naked eye, ensuring you can stare at your diamond for eternity, and never second-guess your selection. As a result, we look for the nicest SI1 clarity diamonds or higher.
          </p>
        </GridItem>
      </Grid>
      <Spacer xl />
      <Grid>
        <GridItem col='1/1' customStyle={css.gridItem}>
          <ImageScale elements={clarityScale} imgHeight={50} />
        </GridItem>
      </Grid>
    </div>
  )
}

export default ClaritySection



// WEBPACK FOOTER //
// ./src/containers/diamond/clarity_section.js